<template>
	<div>
		<div class="page-filter-box">
			<el-row :gutter="20">
				<el-col  :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
					<el-input v-model="params.searchValue" class="input-with-select" size="small">
						<el-select v-model="params.searchType" slot="prepend" placeholder="请选择" style="width:50%;">
							<el-option label="按渠道名称" :value="1"></el-option>
							<el-option label="按参数值" :value="2"></el-option>
						</el-select>
					</el-input>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
					<el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
					<el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="page-btns-box">
			<el-button v-if="$utils.have('/track/management/edit')" type="primary" icon="el-icon-plus" size="small"
				@click="add()">新建渠道</el-button>
		</div>
		<div class="page-list-box">
			<el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
				<el-table-column prop="name" label="渠道名称">
				</el-table-column>
				<el-table-column prop="track" label="track参数值">
				</el-table-column>
				<el-table-column prop="activityId" label="追踪演出id">
				</el-table-column>
				<el-table-column prop="activityName" label="追踪演出名称" min-width="150" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="activityLink" label="专属追踪演出链接" min-width="150" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="commission" label="渠道佣金比">
				</el-table-column>
				<el-table-column prop="createUserName" label="创建人">
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间">
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="230">
					<template slot-scope="scope">
						<el-button
						    v-if="$utils.have('/track/management/edit')"
						    type="text"
						    size="small"
						    icon="el-icon-edit"
							@click="edit(scope.row)"
						    >管理</el-button
						>
						<el-button
						    v-if="$utils.have('/track/management/del')"
						    type="text"
						    size="small"
						    icon="el-icon-delete"
							@click="del(scope.row.id)"
						    >删除</el-button
						>
						<el-button v-if="$utils.have('/track/management/getWxQrcode')" type="text"
							size="small" @click="$refs.showCode.show(scope.row)">渠道码</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div v-if="data" class="page-pagination-box">
			<el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
				:current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
				layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
			</el-pagination>
		</div>
		<add ref="add" @onUpdate="getDataList()"></add>
		<show-code ref="showCode" @onUpdate="getDataList()"></show-code>
	</div>
</template>
<script>
	import Add from './add.vue';
	import showCode from './showCode';
	const defaultParams = {
		pageNo: 1,
		searchType: 1,
		searchValue: ''
	}
	export default {
		components: {
			Add,
			showCode
		},
		data() {
			return {
				data: null,
				dataList: null,
				listLoading: false,
				dataLoading: false,
				downLoading: false,
				params: {
					...defaultParams,
					pageNo: parseInt(this.$route.query.pageNo || 1),
					pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
					searchType: parseInt(this.$route.query.searchType || 1),
					searchValue: this.$route.query.searchValue || "",
				},
			}
		},
		mounted() {
			this.getDataList();
		},
		methods: {
			//获取列表
			getDataList() {
				this.listLoading = true;
				this.$request({
						url: "/track/management/list",
						method: "POST",
						data: {
							...this.params,
						},
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.data = result;
							this.dataList = result.result || [];

						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
					.finally(() => {
						this.listLoading = false;
					});
			},
			//选择pageSize
			handleSizeChange(e) {
			    this.params.pageNo = 1;
			    this.params.pageSize = e;
			    this.getDataList();
			},			
			//搜索
			search() {
				this.params.pageNo = 1;
				this.getDataList();
			},
			//重置搜索
			reset() {
				this.params = {
					...defaultParams,
					pageSize: this.params.pageSize,
				};
				this.getDataList();
			},
			//删除事件
			del(id){
			    this.$confirm('确定要删除吗?', '提示', {
			        type: 'warning',
			        center: true,
			        closeOnClickModal: false
			    }).then(() => {
			        this.listLoading = true;
			        this.$request({
			            url: '/track/management/del',
			            method: 'POST',
			            params: {id:id}
			        }).then(res => {
			            const { state, msg } = res.data;
			            if( state == 1 ){
			                this.getDataList();
			            }else{
			                this.$message.error(msg || '请求失败');
			            }
			        }).catch(() => {
			            this.$message.error('请求错误');
			        }).finally(() => {
			            this.listLoading = false;
			        });
			    })
			},
			add() {
				this.$refs.add.show();
			},
			edit(data){
				this.$refs.add.show(data);
			}
		}
	}
</script>
<style lang="scss" scoped>

</style>